import { AccountVerificationStatus } from "@api-types/account-verification/AccountVerificationType";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export default class GpUsersApiService {
	static baseUrl(context: ApiRequestContextData): string {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/gp-users/`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getAccountVerificationStatus(
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<AccountVerificationStatus> {
		const context = getApiRequestContext(options);
		return await httpClient.get(
			`${this.baseUrl(context)}account-verification-status`,
			this.getRequestHeaders(context)
		);
	}

	static async checkCreditRatingStatus(
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<boolean> {
		const context = getApiRequestContext(options);

		return httpClient.get(
			`${this.baseUrl(context)}/credit-rating-status`,
			this.getRequestHeaders(context)
		);
	}

	static async confirmGracePeriod(
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	): Promise<void> {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			`${this.baseUrl(context)}/confirm-grace-period`,
			null,
			this.getRequestHeaders(context),
			{ responseType: "text" }
		);
	}
}
